import { effect, Injectable, signal, Signal } from '@angular/core';
import { fromEvent, merge, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';

// Writable for debugging
export const isOffline = signal(false);

@Injectable({ providedIn: 'root' })
export class ConnectionService {
    readonly isOffline$ = merge(
        fromEvent(window, 'online').pipe(map(() => false)),
        fromEvent(window, 'offline').pipe(map(() => true)),
        of(!navigator.onLine),
    ).pipe(startWith(!navigator.onLine));

    public isOfflineChange: Signal<boolean> = toSignal<boolean, boolean>(this.isOffline$, { initialValue: !navigator.onLine }) as any;

    constructor() {
        effect(() => {
            isOffline.set(this.isOfflineChange());
        });
    }

}
